import Component from '../../component/component';

export default class SelectExample extends Component {
    static initSelector: string = '.sg-js-select-example';

    private enableButton: HTMLElement;
    private select: HTMLElement;

    constructor(element: HTMLElement) {
        super(element);

        this.enableButton = this.element.querySelector('.sg-js-select-example-button');
        this.select = this.element.querySelector('.sg-select');

        this.enableButton.addEventListener('click', () => {
            this.select.dispatchEvent(new CustomEvent('enableSelect'));
        });
    }
}
